module.exports = __webpack_public_path__ + "img/alpha_tauri.3b1b63cb.jpg";